module.exports = __webpack_public_path__ + "img/010_iss_thumb.922f557e.jpg";